export interface AuthSession {
  authenticated: boolean;
  user: string;
  roles: string[];
  issued: Date;
  expires: Date;
}

export const createSession = (
  authenticated = false,
  user = "",
  roles = [""],
  issued = new Date(),
  expires = new Date()
) => ({
  authenticated: authenticated,
  user: user,
  roles: roles,
  issued: issued,
  expires: expires,
});
